export default __webpack_public_path__ + "static/media/Mark-4-HUD-Targeting (TD).ad79cc25.jpg";